<div class="verification-modal" [class.d--hidden]="isLoading">
  <ng-container>
    <header class="modal__header">
      <h2 [ngStyle]="content && content.color && { color: 'black' }">
        {{ enableVerificationCodeSendAlternateReCaptcha ? content.alternateReCaptchaText?.title : content.text.title }}
      </h2>
      <a class="button button--transparent modal__button--close" (click)="onCloseModal()">
        <i class="icon icon-ui-close--sm" [ngStyle]="content && content.color && { 'background-color': '#' + content.color.color }"></i>
      </a>
    </header>
    <div class="modal__content">
      <div
        class="modal__text"
        [internalInnerHtml]="enableVerificationCodeSendAlternateReCaptcha ? content.alternateReCaptchaText?.body : content.text.body"
        [userEventSource]="userEventSource"
      ></div>
      <air-form
        #formComponent
        *ngIf="!enableVerificationCodeSendAlternateReCaptcha"
        [controls]="form"
        [alternateReCaptchaActions]="alternateReCaptchaActions"
        [userEventSource]="userEventSource"
        (submitted)="submitValues($event)"
      >
      </air-form>
      <div
        *ngIf="enableVerificationCodeValidationAlternateReCaptcha || enableVerificationCodeSendAlternateReCaptcha"
        class="form-group--grecaptcha"
      >
        <air-recaptcha-fallback></air-recaptcha-fallback>
      </div>
    </div>
    <div class="modal__footer--full-width-ends">
      <a
        *ngIf="!enableVerificationCodeSendAlternateReCaptcha"
        class="button button--tertiary button--transparent"
        (click)="resendCode($event)"
        [airButtonLoading]="isResendLoading"
        [class.button--disabled]="isResendDisabled"
        [ngStyle]="content && content.color && { color: '#' + content.color.color }"
      >
        <span>{{ "account.label.resend_verification_code" | translate }}</span>
      </a>
      <a
        type="button"
        (click)="enableVerificationCodeSendAlternateReCaptcha ? sendCodeAlternateReCaptcha() : submit($event)"
        class="button form__button button--cta"
        [airButtonLoading]="isSubmitting"
        [ngStyle]="content && content.color && { 'background-color': '#' + content.color.color }"
      >
        <span>{{ submitLabel }}</span>
      </a>
    </div>
  </ng-container>
</div>
